import * as remodal from 'remodal';
import Swiper from 'swiper';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    remodal;

    const $remodalGalleryHtml = $('<div class="remodal-wrapper remodal-is-closed" style="display: none;"><div data-remodal-id="modal" id="gallery-modal"><button data-remodal-action="close" class="remodal-close"></button><div class="image"></div></div></div>');
    const $mainGalleries = $('.main-gallery');
    const $switchGallery = $('.js-switch-gallery');

    $remodalGalleryHtml.appendTo('body');

    setGalleryHeight();

    $mainGalleries.find('.js-show-gallery').on('click', function(e){
      e.preventDefault();
      $(this).closest('.main-gallery').addClass('hide-read-more');
    });

    $mainGalleries.find('img').on('click', function(e){
      e.preventDefault();
      generateModalGallery($(this)[0]);
    });

    $(document).on('opened', '.remodal', function () {
      //placeGalleryImageIntoModal(current.outerHTML);
      $('.remodal-wrapper').find('.remodal-close').prependTo($('.remodal-wrapper'));
    });

    function generateModalGallery(current) {

      $('#gallery-modal').remodal().open();
      placeGalleryImageIntoModal(current.outerHTML);


      function placeGalleryImageIntoModal(html) {
        $('#gallery-modal').find('.image').html(html);
      }


    }

    $('.js-onchange-gallery').on('change', function(){
      $('.js-switch-gallery').filter('[href="'+$(this).val()+'"]').trigger('click');
    });

    $switchGallery.on('click', function(e) {
      e.preventDefault();
      const id = $(this).attr('href');
      new openGallery(id);
    });

    $(function(){
      $switchGallery.filter(':first-child').click();
      $('.gallery-switchers').removeClass('active');
      $('.slide-navigation').each(function(i,e){
        $(e).appendTo($(e).closest('.main-investments-slider'));
      });
    });

    function setGalleryHeight() {
      $mainGalleries.each(function(i, e){
        const $e = $(e);
        const $img = $e.find('img');

        if($img.length <= 6) {
          $e.addClass('hide-read-more');
        }
      });
    }

    $('body').on('click', '.gallery-switchers', function(){
      $(this).toggleClass('active');
    });

    function openGallery(id) {
      const $currentSwitchGallery = $switchGallery.filter('[href="'+ id +'"]');
      if($currentSwitchGallery.hasClass('active')) {
        return;
      }

      $switchGallery.removeClass('activated');
      $currentSwitchGallery.addClass('activated');

      $mainGalleries.find('.col-md-4').removeClass('activated');

      setTimeout(function(){
        $mainGalleries.removeClass('active');
        $mainGalleries.filter(id).addClass('active');
      }, 300);

      setTimeout(function() {
        $mainGalleries.filter(id).find('.col-md-4').addClass('activated');
      }, 600);

    }



    function menu() {
      let $mainBar;
      let $sellerBox;
      let stickyHeight;
      let scrollPosition;
      let lastScrollPosition;
      let scrollName = 'up';
      const $html = $('html');

      function setElements() {
        $mainBar = $('.main-bar');
        $sellerBox = $('.seller-box');
        stickyHeight = $('header.banner').outerHeight() + $sellerBox.outerHeight();
      }

      function buildMenu() {
        $('<div class="sticky"></div>')
          .append($mainBar.clone(true))
          .append($sellerBox.clone(true)).insertAfter('header.banner');
      }

      function checkIfUserReachedTheBar() {
        if(stickyHeight <= scrollPosition) {
          $html.addClass('enable-sticky');
        } else {
          $html.removeClass('enable-sticky');
        }
      }

      function debounce(fn, delay) {
        var timeout = null;
        return function () {
          var args = arguments;
          var context = this;
          if (!timeout) {
            timeout = setTimeout(function () {
              timeout = 0;
              return fn.apply(context, args);
            }, delay);
          }
        }
      }

      function detectUserScrollDirection() {
        if(scrollName === 'down' && lastScrollPosition - scrollPosition > 60) {
          scrollName = 'up';
          $html.removeClass('scroll-down').addClass('scroll-up');
        } else if( scrollName ==='up' && lastScrollPosition - scrollPosition  < 0) {
          scrollName = 'down';
          $html.removeClass('scroll-up').addClass('scroll-down');
        }
        lastScrollPosition = scrollPosition;
      }

      function init() {
        setElements();
        buildMenu();
        $(window).on('scroll', function() {
          window.requestAnimationFrame(debounce(function() {
            scrollPosition = (window.pageYOffset || document.documentElement.scrollTop);
            checkIfUserReachedTheBar();
            detectUserScrollDirection();
          }, 300));
        });
      }

      return init();
    }


    $(function(){
      setTimeout(function(){
        menu();
      }, 400);
    });


    if($('article').hasClass('status_inwestycji-zrealizowane')) {
      $('body').addClass('status_inwestycji-zrealizowane');
    }


    $('.navbar').on('shown.bs.collapse', function () {
      $('body').addClass('expanded-main-menu');
    })
    $('.navbar').on('hidden.bs.collapse', function () {
      $('body').removeClass('expanded-main-menu');
    });

    $('body').find('p').each(function(i,e) {
      const $e = $(e);
      if(!$e.html().length) {
        $e.remove();
      }
    });

    $('.top-bar')
    .find('.widget_polylang .current-lang')
    .on('click onmouseenter', function(e) {
      e.preventDefault();
      const $el = $(this);
      const $ulParent = $el.closest('ul');
      if(!$ulParent.hasClass('active')) {
        $ulParent.addClass('active');
      } else {
        $ulParent.removeClass('active');
      }
    });

    $('body').on('click', function(e){

      if(e.target.nodeName !== 'A'){
        $('.top-bar').find('.widget_polylang ul.active').removeClass('active');
      }

    });

    $('.main-bar').find('.menu-item-has-children').on('mouseenter mouseleave', function(e) {
      const $el = $(this);
      if(e.type === 'mouseenter') {
        $el.addClass('active');
      } else {
        setTimeout(function(){
          $el.removeClass('active');
        }, 500);
      }
    });

    $('input, textarea').on('focus', function(){
      var input = $(this);
      var label = $(this).closest('label');
      label.addClass('focussed');
      input.on('blur', function(){
        label.removeClass('focussed');
        input.off('blur');
      });
    }).on('change', function() {
      var input = $(this);
      var label = $(this).closest('label');

      if(input.attr('aria-invalid') === 'true') {
        label.addClass('invaild');
      } else {
        label.removeClass('invaild');
      }
    });

    $('body').on('wpcf7submit', function() {
      setTimeout(function() {
        $('.wpcf7-form').find('input').trigger('change');
      }, 200);
    });


    $('input[type="checkbox"').on('change', function(){
      var item = $(this);
      var label = $(this).closest('label');

      if(item.is(':checked')) {
        label.addClass('checked');
      } else {
        label.removeClass('checked');
      }
    });


    $('body').on('click', '.js-scroll-to-element', function(e){
      e.preventDefault();

      const target = $(this).data('target');

      $('html, body').animate({
        scrollTop: parseInt($(target).offset().top - jQuery('.sticky').height()),
      }, 2000);

    });

    $('body').on('click', '.main-data .js-scroll-to', function(e){
      e.preventDefault();

      $('html, body').animate({
        scrollTop: parseInt($('.location-box').offset().top - jQuery('.sticky').height()),
      }, 2000);

    });


    setTimeout(function() {
    const swipe = new Swiper('.swiper-container', {
      // Optional parameters
      slidesPerView: 3,
      loop: false,
      spaceBetween: 30,

      breakpoints: {
        10: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        300: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })

    window.myswiper = swipe;

    if (swipe.originalParams.loop && swipe.loopedSlides < swipe.originalParams.slidesPerView) {
      swipe.params.slidesPerView = swipe.loopedSlides;
      swipe.destroy(false, false);
      swipe.init();
    }


    $('body').on('click', '.swiper-button-next', function(){
      updateNavigationState();
      if(swipe.allowSlideNext) {
        swipe.slideNext();
      }
    });

    $('body').on('click', '.swiper-button-prev', function(){
      updateNavigationState()
      if(swipe.allowSlidePrev) {
        swipe.slidePrev();
      }
    });


    function updateNavigationState() {
      if(swipe.allowSlideNext) {
        $('.swiper-button-next').removeClass('disabled');
      } else {
        $('.swiper-button-next').addClass('disabled');
      }

      if(swipe.allowSlidePrev) {
        $('.swiper-button-prev').removeClass('disabled');
      } else {
        $('.swiper-button-prev').addClass('disabled');
      }
    }


  }, 100);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js